const soundsList = [
  "collide",
  "bounce",
  "jump",
  "drive",
  "bouncify",
  "break in half",
  "collectible",
  "finish-line",
  "hazard",
  "invulnerable",
  "portal",
  "projectile",
  "respawn",
  "spawn",
  "walk",
]; // Add other sound names as needed

module.exports = soundsList;
